// extracted by mini-css-extract-plugin
export var avatar = "_pv-3";
export var avatarContainer = "_pv-2";
export var avatarSpacer = "_pv-5";
export var avatarSpacerContainer = "_pv-4";
export var avatarStackContainer = "_pv-1";
export var bubble = "_pv-0";
export var remainderBubble = "_pv-6";